import * as React from "react"

const SvgAlarmRing = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 19.714a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288h1v-7q0-2.075 1.25-3.687a5.77 5.77 0 0 1 3.25-2.113v-.7q0-.624.437-1.062A1.45 1.45 0 0 1 12 2.714q.625 0 1.062.438.438.437.438 1.062v.7q2 .5 3.25 2.113T18 10.714v7h1q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm7 3q-.824 0-1.413-.587A1.93 1.93 0 0 1 10 20.714h4q0 .825-.588 1.413a1.93 1.93 0 0 1-1.412.587m-4-5h8v-7q0-1.65-1.175-2.825T12 6.714c-1.65 0-2.042.392-2.825 1.175Q8 9.064 8 10.714zm-5-7a.91.91 0 0 1-.713-.325.92.92 0 0 1-.237-.75A9.6 9.6 0 0 1 3.1 6.152a10.1 10.1 0 0 1 2.175-2.813 1 1 0 0 1 .737-.25.84.84 0 0 1 .663.375q.25.351.2.75a1.12 1.12 0 0 1-.375.7 7.9 7.9 0 0 0-1.6 2.15 8.3 8.3 0 0 0-.825 2.65 1.14 1.14 0 0 1-.35.713 1 1 0 0 1-.725.287m18 0a1 1 0 0 1-.725-.287q-.3-.288-.35-.713a8.3 8.3 0 0 0-.825-2.65 7.9 7.9 0 0 0-1.6-2.15 1.12 1.12 0 0 1-.375-.7 1.03 1.03 0 0 1 .2-.75.84.84 0 0 1 .662-.375q.413-.024.738.25 1.325 1.2 2.175 2.813a9.6 9.6 0 0 1 1.05 3.487.92.92 0 0 1-.238.75.91.91 0 0 1-.712.325" />
  </svg>
)
export default SvgAlarmRing
